"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolPicker = void 0;
const mithril_1 = require("../../mithril");
const theme_1 = require("../theme");
const CSS = {
    container: 'c-ToolPicker'
};
const Style = {
    [CSS.container]: {
        display: 'flex',
        flexDirection: 'column',
        padding: '6px'
    }
};
(0, theme_1.addStyles)(Style);
exports.ToolPicker = {
    view({ children = [], className = '' } = {}) {
        return (0, mithril_1.m)('div', {
            className: `${CSS.container} ${className}`
        }, children);
    }
};
//# sourceMappingURL=tool.picker.js.map